import { Link } from "react-router-dom";
import SEOHead from "../components/SEOHead";
import { countrySummaries, getLocationsByCountrySlug, locations } from "../data/locations";
import { serviceCatalog } from "../data/services";

export default function HTMLSitemap() {
  return (
    <>
      <SEOHead
        title="Sitemap | Obsidian Web Labs"
        description="Browse all service, country, city, and location-specific pages across Obsidian Web Labs."
        canonicalUrl="https://obsidianweblabs.com/sitemap"
      />

      <section style={{ background: "#050505", color: "#F8F4EC", minHeight: "100vh", padding: "120px 24px" }}>
        <div style={{ maxWidth: 1140, margin: "0 auto" }}>
          <h1 style={{ fontSize: "clamp(32px, 5vw, 52px)", marginBottom: 22 }}>Sitemap</h1>

          <h2 style={{ marginBottom: 12, fontSize: 24 }}>Core pages</h2>
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 28 }}>
            {["/", "/services", "/industries", "/work", "/about", "/contact", "/blog"].map((route) => (
              <Link key={route} to={route} style={{ color: "#D4A843", textDecoration: "none" }}>{route}</Link>
            ))}
          </div>

          <h2 style={{ marginBottom: 12, fontSize: 24 }}>Country pages</h2>
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 28 }}>
            {countrySummaries.map((country) => (
              <Link key={country.slug} to={`/${country.slug}`} style={{ color: "#D4A843", textDecoration: "none" }}>
                /{country.slug}
              </Link>
            ))}
          </div>

          <h2 style={{ marginBottom: 12, fontSize: 24 }}>City pages</h2>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: 10, marginBottom: 28 }}>
            {locations.map((location) => (
              <Link key={location.slug} to={`/${location.countrySlug}/${location.slug}`} style={{ color: "#F8F4EC", textDecoration: "none" }}>
                /{location.countrySlug}/{location.slug}
              </Link>
            ))}
          </div>

          <h2 style={{ marginBottom: 12, fontSize: 24 }}>Service-location pages</h2>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 10 }}>
            {countrySummaries.flatMap((country) =>
              getLocationsByCountrySlug(country.slug).slice(0, 5).flatMap((location) =>
                serviceCatalog.slice(0, 8).map((service) => (
                  <Link
                    key={`${service.slug}-${location.slug}`}
                    to={`/services/${service.slug}/${location.slug}`}
                    style={{ color: "#B8B2A8", textDecoration: "none" }}
                  >
                    /services/{service.slug}/{location.slug}
                  </Link>
                ))
              )
            )}
          </div>
        </div>
      </section>
    </>
  );
}
